// extracted by mini-css-extract-plugin
export default {"container":"SaveDataComponent_container__sSne5","navLink":"SaveDataComponent_navLink__Xr2Dh"};